import React from "react"

export default function Emoji({ text }) {
  return (
    <span role="img" aria-labelledby="jsx-a11y/accessible-emoji">
      {text}
    </span>
  )
}
